import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Admin } from "@mol-limo-reg/admin-api";
import { SuccessSnackbarComponent } from "../../snackbars/success-snackbar/success-snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, of } from "rxjs";
import { SnackbarService } from "../../../services/snackbar.service";
import { AdminService } from "../../../services/admin.service";

@Component({
  selector: 'app-deactivate-admin-dialog',
  templateUrl: './deactivate-admin-dialog.component.html',
  styleUrls: ['./deactivate-admin-dialog.component.scss']
})
export class DeactivateAdminDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DeactivateAdminDialogComponent>,
    private snackbarService: SnackbarService,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: Admin
  ) { }

  ngOnInit(): void {
  }

  onDeactivateClicked(): void {
    let id = this.data.id;
    let name = this.data.name;
    let email = this.data.email;
    this.adminService.deactivateAdmin$(id)
      .pipe(
        catchError(() => {
          this.snackbarService.error(`”${name} (${email})” deaktiválása során hiba lépett fel!`);
          this.dialogRef.close({ success: false });
          return of();
        })
      )
      .subscribe(() => {
        this.snackbarService.success(`”${name} (${email})” sikeresen deaktiválva!`)
        this.dialogRef.close({ success: true });
      })
  }

}
